import {configureStore} from '@reduxjs/toolkit';
//Imports the reduccers from different Slices

import userReducer from './userSlice';
import labReducer from './labSlice';
import medicalReducer from './medicalSlice';
// import labReducer from './labSlice';
import businessReducer from './businessSlice';

//Create the redux store
const store = configureStore({
	//combines all slice reducers into a single root reducer
	reducer: {
		//user slice -> accessible via state.user

		user: userReducer,

		//bussiness slice -> accessible via state.business
		business: businessReducer,

		//lab slice -> accessible via state.lab

		lab: labReducer,

		//medical slice -> accessible via state.medical

		medical: medicalReducer
}
});

//export the store to be provided to the react app
//using the provider store={store}
export default store;
